import { validationsStore } from '@apia/validations';
import { generateFormsContent } from './generateInformation/generateFormsContent';
import { resolveResponseResult } from './fillInformation/resolveResponseResult';
import { getFormsAssistantFormName } from '../../getFormsAssistantFormName';
import { getFormsAssistantConfiguration } from '../../getFormsAssistantConfiguration';
import { IAttachment } from '@apia/ai';

export type AIMessageAttachments = {
  name: string;
  extension: string;
  value: string;
  description: string;
};

export const needComment = () =>
  validationsStore.getFieldStore(
    getFormsAssistantFormName(),
    getFormsAssistantConfiguration().OBSERVATIONS.name,
  )?.value === true;

export const runPromptForms = async (props: {
  // isForAutoComplete: boolean;
  isPhone: boolean;
  prompt?: string;
  rowInfo?: { gridId: string; rowIndex: number };
  files?: IAttachment[];
}) => {
  // const formsInformation = await resolveGetFormsInformation(
  //   props.isForAutoComplete,
  //   props.rowInfo,
  // );

  // if (formsInformation) {
  //   needComment() && addObservationsForm(formsInformation);

  const result = await generateFormsContent(
    // formsInformation,
    // props.isForAutoComplete
    //   ? 'processFormsAutoComplete'
    'processFormsAssistant',
    props.prompt,
    props.files,
  );

  if (result?.data) {
    await resolveResponseResult(
      result.data,
      // props.isForAutoComplete,
      props.isPhone,
    );
  }
  // }
};
